module.exports = __webpack_public_path__ + "img/capitol_hill_library_9224.924836d3.jpg";